import { DEFAULT_ALTERNATE_NAME } from 'globalConstants';

const TermOfAgreement = () => (
  <div className='flex w-full flex-col space-y-[24px]'>
    <h1 id='dieu-khoan-thoa-thuan' className='text-[24px] font-[600] leading-[30px]'>
      3. Điều khoản thỏa thuận
    </h1>
    <div className='flex w-full flex-col space-y-[12px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='dieu-khoan-thoa-thuan-3.1'>
        3.1 Điều khoản thỏa thuận
      </h2>
      <span className='text-[14px] leading-[24px]'>
        <b>{DEFAULT_ALTERNATE_NAME}</b> xin chân thành cám ơn Khách hàng đã đồng hành sử dụng dịch
        vụ của chúng tôi. Trước khi sử dụng các dịch vụ trên trang website của{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>, xin vui lòng đọc kỹ và ghi nhớ Điều khoản Thoả thuận này.
        Khi đối tác truy cập vào website <b> {DEFAULT_ALTERNATE_NAME} </b>
        có nghĩa Khách hàng đã đọc hiểu chấp nhận và đồng ý các{' '}
        <b className='font-[600] text-primary underline underline-offset-2'>
          ĐIỀU KHOẢN THỎA THUẬN.
        </b>
      </span>
      <span className='text-[14px] leading-[24px]'>
        Quý Khách hàng đồng thuận truy cập website <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Khi <b>{DEFAULT_ALTERNATE_NAME}</b> với bất kỳ một cá nhân doanh nghiệp tổ chức đơn vị nào
        khác, hoặc những người đã sử dụng website <b>{DEFAULT_ALTERNATE_NAME}</b> (được gọi chung là
        Người sử dụng hoặc đối tác, hoặc khách hàng).
      </span>
      <span className='text-[14px] leading-[24px]'>
        <b>{DEFAULT_ALTERNATE_NAME}</b> là website được thiết kế giao diện thân thiện, hiện đại, kết
        nối mọi tiện ích nhanh chóng đến khách hàng về lĩnh vực bất động sản, bao gồm đăng thông tin
        quảng cáo nhu cầu mua/bán/thuê/cho thuê bất động sản, lưu trữ bất động sản, có thể chứa các
        chức năng mô phỏng Xem bản đồ quy hoạch diện tích, xem định giá bất động sản, xem tin tức,
        liên kết, sản phẩm nghệ thuật điện tử, hình ảnh động, âm thanh, video, phần mềm, và các nội
        dung khác trên website của <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2
        className='text-[16px] font-[600] uppercase'
        id='trach-nhiem-va-nghia-vu-cua-nguoi-su-dung'
      >
        3.2 Trách nhiệm và nghĩa vụ của người sử dụng
      </h2>
      <span className='text-[14px] leading-[24px]'>
        1. Bạn cần đồng ý với Thỏa thuận sử dụng dịch vụ của <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        2. Khách hàng có trách nhiệm bảo vệ mật khẩu truy cập, và trách nhiệm của việc đăng nhập
        bằng mật khẩu riêng của khách hàng, do hoặc không do bạn trực tiếp đăng nhập.
      </span>
      <span className='text-[14px] leading-[24px]'>
        3. Khi bạn đăng ký tài khoản tại <b>{DEFAULT_ALTERNATE_NAME}</b>: bạn nên khai báo đúng
        thông tin trung thực không nên cung cấp thông tin giả mạo; không nên đăng ký đăng nhập tên
        tài khoản trùng của thành viên khác khi chưa có sự đồng ý của thành viên đó, nếu cố tình vi
        phạm bạn sẽ không được hưởng những chính sách khách hàng ưu đãi, chính sách thành viên đội
        nhóm, hoặc bị khóa tài khoản đang sử dụng.
      </span>
      <span className='text-[14px] leading-[24px]'>
        4. Bạn đồng ý rằng không sử dụng Dịch Vụ vào các mục đích phi pháp, bị cấm theo quy định của
        pháp luật (ở đây được ngầm hiểu là Pháp luật nước Cộng Hòa Xã Hội Chủ Nghĩa Việt Nam) hoặc
        vi phạm các quyền hợp pháp, gây trở ngại, hạn chế việc sử dụng Dịch vụ của Người dùng khác,
        cụ thể không lợi dụng website nhằm mục đích:
      </span>
      <span className='text-[14px] leading-[24px]'>
        a. Đăng tải thông tin Chống lại nhà nước Cộng hòa xã hội chủ nghĩa Việt Nam; gây hại đến an
        ninh quốc gia, trật tự, an toàn xã hội; phá hoại khối đại đoàn kết toàn dân; tuyên truyền
        chiến tranh xâm lược; gây hận thù, mâu thuẫn giữa các dân tộc, sắc tộc, tôn giáo; tuyên
        truyền, kích động bạo lực, dâm ô, đồi trụy, tội ác, tệ nạn xã hội, mê tín dị đoan; đe dọa,
        văn tục, phá hoại thuần phong, mỹ tục của website <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        b. Đưa các thông tin xuyên tạc, vu khống, xúc phạm uy tín của tổ chức; danh dự, nhân phẩm
        của người dùng khác.
      </span>
      <span className='text-[14px] leading-[24px]'>
        c. Lợi dụng Internet để quảng cáo, tuyên truyền, mua bán hàng hóa, dịch vụ thuộc danh mục
        cấm theo quy định của pháp luật.
      </span>
      <span className='text-[14px] leading-[24px]'>
        d. Gây rối, phá hoại hệ thống thiết bị và cản trở trái pháp luật việc quản lý, cung cấp, sử
        dụng các dịch vụ Internet và thông tin điện tử trên Internet website của{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        e. Đánh cắp và sử dụng trái phép mật khẩu, khóa mật mã và thông tin riêng của các tổ chức,
        cá nhân trên website của <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        f. Tạo ra và cài đặt các chương trình virus máy tính, phần mềm gây hại để thực hiện một
        trong những hành vi quy định tại Điều 71 Luật Công nghệ thông tin.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Bạn không được gây thiệt hại, phá hoại, làm suy yếu hoặc hư hại Dịch Vụ và website của{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Bạn không được phát tán các tập tin chứa virus, các chương trình phá hoại, hoặc các tập tin,
        chương trình phần mềm gây hại đến Dịch vụ và việc sử dụng ổn định của người dùng khác tại
        website của <b>{DEFAULT_ALTERNATE_NAME}</b>
      </span>
      <span className='text-[14px] leading-[24px]'>Các liên hệ đến website khác:</span>
      <span className='text-[14px] leading-[24px]'>
        Để thuận tiện cho việc sử dụng của Người dùng, <b>{DEFAULT_ALTERNATE_NAME}</b> có thể cung
        cấp cho Người dùng một số liên kết đến các website khác. Các website liên kết này không
        thuộc quyền sở hữu của <b>{DEFAULT_ALTERNATE_NAME}</b>, do đó
        <b> {DEFAULT_ALTERNATE_NAME}</b> sẽ không chịu trách nhiệm về mọi thông tin, dịch vụ và nội
        dung của những Website liên kết này.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Người dùng chịu hoàn toàn trách nhiệm trong việc sử dụng ổn định của người dùng khác.
      </span>
    </div>
    <div className='h-[5px] w-full border-y border-dashed' />
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='so-huu-tri-tue'>
        3.3 Sở hữu trí tuệ
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Bạn đồng ý sử dụng Dịch Vụ website của <b>{DEFAULT_ALTERNATE_NAME}</b> thì bạn cũng đã đồng
        ý quyền sử hữu trí tuệ của website <b>{DEFAULT_ALTERNATE_NAME}</b>. Trong thời đại công nghệ
        thông tin việc thiết kế và tạo ra một website khá là phổ biến. Tuy nhiên, để xây dựng lên
        một website với những nội dung phổ biến với người dùng là cả một quá trình dài của chúng
        tôi. Khi chúng tôi đã đăng ký bản quyền sở hữu trí tuệ thì chúng tôi đã có chỗ đứng nhất
        định trên thế giới mạng , chúng tôi không cho phép bất kỳ ai, bất kỳ hành vi nào cạnh tranh
        không lành mạnh như sao chép nội dung, ăn cắp ý tưởng web, giáo trình, tài liệu, kịch bản,
        logo, âm thanh, giao diện, màu sắc thương hiệu uy tín, bản quyền website dưới hình thức tác
        phẩm mỹ thuật ứng dụng cho phần giao diện trang chủ, trang chuyên mục chức năng, và bản
        quyền website dưới hình thức chương trình máy tính cho web code để thiết kế ra website đó.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='chinh-sach-bao-mat'>
        3.4 Chính sách bảo mật
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Website <b>{DEFAULT_ALTERNATE_NAME}</b> có thể sử dụng cookie và công nghệ quản lý các tính
        năng được cung cấp. Cookie và công nghệ quản lý hữu ích cho việc thu thập thông tin như loại
        trình duyệt và hệ điều hành, quản lý số lượng khách truy cập vào trang web, và hiểu biết
        khách truy cập sử dụng trang web như thế nào từ đó tạo sự liên kết đồng nhất kết nối về
        thông tin, chia sẻ những nhu cầu tương tác với mọi khách hàng đang sử dụng web tại{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>. Vì vậy, nếu trước đó bạn đã cung cấp thông tin cá nhân định
        danh. Khi sử dụng trang web <b>{DEFAULT_ALTERNATE_NAME}</b>, bạn đang chấp nhận những điều
        được mô tả trong chính sách bảo mật. Những điều này có thể thay đổi, nhưng bất kỳ thay đổi
        nào cũng đều sẽ được đăng lên và thay đổi sẽ chỉ áp dụng cho các hoạt động hỗ trợ người dùng
        tại <b>{DEFAULT_ALTERNATE_NAME}</b>, Bạn nên xem lại chính sách bảo mật bất cứ khi nào bạn
        truy cập trang web để đảm bảo rằng mình hiểu các thông tin cá nhân mà bạn cung cấp sẽ được
        sử dụng như thế nào. Chính sách của chúng tôi là giữ kín thông tin mật khẩu cá nhân của
        người dùng trang web, hoàn toàn bí mật và chỉ dùng cho mục đích nội bộ, nếu một ai đó có
        hành vi đăng nhập bất thường, chúng tôi sẽ thông báo cho bạn qua email hoặc số điện thoại.
        Chúng tôi sẽ không chia sẻ thông tin mật khẩu cá nhân của bạn với bất kỳ bên nào khác. Hãy
        yên tâm rằng chúng tôi tôn trọng sự riêng tư của bạn và xử lý dữ liệu trên tinh thần kết nối
        cộng đồng, hỗ trợ mọi thành viên sử dụng web tại <b>{DEFAULT_ALTERNATE_NAME}</b> một cách
        hài hòa nhất, trách nhiệm nhất.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='nhuong-quyen'>
        3.5 Xác nhận hoặc nhượng quyền
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Để nâng tầm, nâng cấp các chức năng của website <b>{DEFAULT_ALTERNATE_NAME}</b> với tốc độ
        thành công nhanh nhất, chúng tôi cần thêm doanh nghiệp hoặc cá nhân đồng hành, nếu chúng tôi
        xác lập, xác nhập hoặc được mua lại bởi bất kỳ doanh nghiệp hay cá nhân nào, vì thế các
        thông tin điều khoản quản lý sẽ được chuyển giao cho cá nhân hoặc tổ chức được mua lại,
        nhưng vẫn được bảo vệ theo chính sách bảo mật của luật định điều khoản, chúng tôi sẽ thông
        báo khi có thay đổi cần thiết để không bị ảnh hưởng hay gián đoạn công việc của khách hàng.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='co-che-giai-quyet-khieu-nai'>
        3.6 Cơ chế giải quyết khiếu nại
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Quy trình hỗ trợ giải quyết khiếu nại/ phản ảnh
      </span>
      <span className='text-[14px] leading-[24px]'>
        Mọi trường hợp xảy ra tranh chấp khiếu nại Người mua/bán/cho thuê/thuê sẽ tự giải quyết bằng
        phương pháp thỏa thuận. Trong trường hợp thỏa thuận không thành công sẽ nhờ đến sự can thiệp
        của cơ quan quy định của pháp luật Việt Nam để xử lý. <b>{DEFAULT_ALTERNATE_NAME}</b> là đơn
        vị kết nối và cung cấp thông tin bất động sản giữa Người mua/bán/cho thuê/thuê và sẽ không
        có trách nhiệm liên đới mọi thỏa thuận, mọi giao dịch nào của các bên Người mua/bán/cho
        thuê/thuê.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Người mua/bán/cho thuê/thuê khi đăng tin phải nêu rõ các thông tin về sản phẩm, cách thức
        mua hàng, đúng đủ, theo đúng quy định của pháp luật. Trong trường hợp phát sinh tranh chấp,
        quy trình giải quyết được thực hiện theo các bước sau, người mua/bán/cho thuê/thuê có vai
        trò và trách nhiệm cùng tham gia giải quyết các vấn đề phát sinh khi có lệnh triệu tập của
        cơ quan pháp luật không yêu cầu <b>{DEFAULT_ALTERNATE_NAME}</b> tham gia giải quyết.
      </span>
      <span className='text-[14px] font-[600] leading-[24px]'>
        Bước 1: Tiếp nhận phản hồi, khiếu nại
      </span>
      <span className='text-[14px] leading-[24px]'>
        Thành viên Người mua/bán/cho thuê/thuê khi có thắc mắc hoặc khiếu nại về tin đăng hoặc các
        dịch vụ xin liên hệ qua email hotro@
        <b>{DEFAULT_ALTERNATE_NAME}</b>. Thành viên có thể gửi phản ánh tại mục “Liên hệ” đến Bộ
        Phận quản lý.
      </span>
      <span className='text-[14px] font-[600] leading-[24px]'>Bước 2: Xử lí khiếu nại</span>
      <span className='text-[14px] leading-[24px]'>
        Bộ phận Chăm Sóc Khách Hàng của <b>{DEFAULT_ALTERNATE_NAME}</b> sẽ tiếp nhận các khiếu nại
        của thành viên Người mua/bán/cho thuê/thuê, tùy theo tính chất và mức độ của khiếu nại thì
        bên <b>{DEFAULT_ALTERNATE_NAME}</b> sẽ có những biện pháp cụ thể hỗ trợ Người mua/bán/cho
        thuê/thuê để giải quyết tranh chấp đó trong phạm vi cho phép.
      </span>
      <span className='text-[14px] font-[600] leading-[24px]'>
        Bước 3: Trường hợp nằm ngoài khả năng kiểm soát và thẩm quyền của {DEFAULT_ALTERNATE_NAME}
      </span>
      <span className='text-[14px] leading-[24px]'>
        Thành viên Người mua/bán/cho thuê/thuê khi có thắc mắc hoặc khiếu nại về tin đăng hoặc các
        dịch vụ xin liên hệ qua email hotro@
        <b>{DEFAULT_ALTERNATE_NAME}</b>. Thành viên có thể gửi phản ánh tại mục “Liên hệ” đến Bộ
        Phận quản lý.
      </span>
      <span className='text-[14px] leading-[24px]'>
        Thành viên Người mua/bán/cho thuê/thuê khi có thắc mắc hoặc khiếu nại về tin đăng hoặc các
        dịch vụ xin liên hệ qua email hotro@
        <b>{DEFAULT_ALTERNATE_NAME}</b>. Thành viên có thể gửi phản ánh tại mục “Liên hệ” đến Bộ
        Phận quản lý.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='quy-dinh-khi-dang-tin-va-quang-cao'>
        3.7 Quy định đăng tin và quảng cáo
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Để nâng tầm, nâng cấp các chức năng của website <b>{DEFAULT_ALTERNATE_NAME}</b> với tốc độ
        thành công nhanh nhất, chúng tôi cần thêm doanh nghiệp hoặc cá nhân đồng hành, nếu chúng tôi
        xác lập, xác nhập hoặc được mua lại bởi bất kỳ doanh nghiệp hay cá nhân nào, vì thế các
        thông tin điều khoản quản lý sẽ được chuyển giao cho cá nhân hoặc tổ chức được mua lại,
        nhưng vẫn được bảo vệ theo chính sách bảo mật của luật định điều khoản, chúng tôi sẽ thông
        báo khi có thay đổi cần thiết để không bị ảnh hưởng hay gián đoạn công việc của khách hàng.
      </span>
      <span className='text-[14px] font-[600] leading-[24px]'>Điều 1. Phạm vi điều chỉnh</span>
      <span className='text-[14px] leading-[24px]'>
        1. Quy định về hoạt động đăng tin quảng cáo; quyền và nghĩa vụ của tổ chức, cá nhân tham gia
        hoạt động đăng tin quảng cáo phải theo quy định tại <b>{DEFAULT_ALTERNATE_NAME}</b> khi bạn
        đã chọn <b>{DEFAULT_ALTERNATE_NAME}</b> để đăng tin quảng cáo thì bạn đã chấp nhận mọi điều
        khoản đăng tin tại điều.
      </span>
      <span className='text-[14px] leading-[24px]'>Giải thích từ ngữ</span>
      <span className='text-[14px] font-[600] leading-[24px]'>Điều 2. Giải thích từ ngữ</span>
      <span className='text-[14px] leading-[24px]'>
        Quy định cách thức và từ ngữ dưới đây được hiểu như sau:
      </span>
      <span className='text-[14px] leading-[24px]'>
        1. Đăng tin, Quảng cáo là việc sử dụng các phương tiện nhằm giới thiệu đến công chúng sản
        phẩm, hàng hóa, dịch vụ của tổ chức, cá nhân đăng tin, quảng cáo.
      </span>
      <span className='text-[14px] leading-[24px]'>
        2. Sản phẩm quảng cáo bao gồm nội dung và hình thức quảng cáo được thể hiện bằng hình ảnh,
        âm thanh, tiếng nói, chữ viết, biểu tượng, màu sắc, ánh sáng và các hình thức tương tự. Tất
        cả phải phải điền thông tin đủ vào những nơi bắt buộc có sao đỏ (*) về câu từ phải lịch sự,
        có dấu, rõ ràng, tiêu đề viết hoa và đủ ý.
      </span>
      <span className='text-[14px] leading-[24px]'>
        3. Người đăng tin quảng cáo tại <b>{DEFAULT_ALTERNATE_NAME}</b> phải chịu mọi trách nhiệm
        khi đăng tin quảng cáo của mình, trường hợp xảy ra tranh chấp khiếu nại Người mua/ bán/cho
        thuê/ thuê sẽ tự giải quyết bằng phương pháp thỏa thuận và sẽ không liên quan đến{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>. Trong trường hợp Người mua/bán/cho thuê/thuê thỏa thuận
        không thành công sẽ nhờ đến sự can thiệp của cơ quan quy định của pháp luật Việt Nam để xử
        lý.
      </span>
    </div>
  </div>
);

export default TermOfAgreement;
